module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }), _vm._v(" "), _c('h3', {
    staticClass: "calibre3"
  }, [_vm._v("Publication History")]), _vm._v(" "), _c('p', {
    staticClass: "s1"
  }, [_vm._v("1. "), _c('span', {
    staticClass: "c"
  }, [_c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/OPS/chapter2"
    }
  }, [_vm._v("Nights of the Round Table")])])]), _vm._v(" "), _c('p', {
    staticClass: "s1"
  }, [_vm._v("first published in "), _c('span', {
    staticClass: "c1"
  }, [_vm._v("Knights Fantastic")]), _vm._v(", edited by Martin H. Greenberg & John Helfers, DAW Books Inc., 2002; collected in "), _c('span', {
    staticClass: "c1"
  }, [_vm._v("Relative Magic")]), _vm._v(", Meisha Merlin, 2003")]), _vm._v(" "), _c('p', {
    staticClass: "s1"
  }, [_vm._v("2. "), _c('span', {
    staticClass: "c"
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "href": "#/OPS/chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Little Girls Are Made Of")])])]), _vm._v(" "), _c('p', {
    staticClass: "s1"
  }, [_vm._v("first published in "), _c('span', {
    staticClass: "c1"
  }, [_vm._v("Magic in Ithkar 3")]), _vm._v(", edited by Andre Norton & Robert Adams, TOR, Oct. 1986")]), _vm._v(" "), _c('p', {
    staticClass: "s1"
  }, [_vm._v("3. "), _c('span', {
    staticClass: "c"
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "href": "#/OPS/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blood in the Water")])])]), _vm._v(" "), _c('p', {
    staticClass: "s1"
  }, [_vm._v("first published in "), _c('span', {
    staticClass: "c1"
  }, [_vm._v("Army of the Fantastic")]), _vm._v(", edited by John Marco & John Helfers, DAW Books Inc., 2007; collected in "), _c('span', {
    staticClass: "c1"
  }, [_vm._v("Finding Magic")]), _vm._v(", ISFiC Press, 2007")]), _vm._v(" "), _c('p', {
    staticClass: "s1"
  }, [_vm._v("4. "), _c('span', {
    staticClass: "c"
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "href": "#/OPS/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Woman’s Work")])])]), _vm._v(" "), _c('p', {
    staticClass: "s1"
  }, [_vm._v("first published in "), _c('span', {
    staticClass: "c1"
  }, [_vm._v("If I Were An Evil Overlord")]), _vm._v(", edited by Martin H. Greenberg, DAW Books Inc., 2007; collected in "), _c('span', {
    staticClass: "c1"
  }, [_vm._v("Finding Magic")]), _vm._v(", ISFiC Press, 2007")]), _vm._v(" "), _c('p', {
    staticClass: "s1"
  }, [_vm._v("5. "), _c('span', {
    staticClass: "c"
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "href": "#/OPS/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Succession")])])]), _vm._v(" "), _c('p', {
    staticClass: "s1"
  }, [_vm._v("first published in "), _c('span', {
    staticClass: "c1"
  }, [_vm._v("Pharaoh Fantastic")]), _vm._v(", edited by Martin H. Greenberg & Brittiany A. Koren, DAW Books Inc., 2002; collected in "), _c('span', {
    staticClass: "c1"
  }, [_vm._v("Relative Magic")]), _vm._v(", Meisha Merlin, 2003")]), _vm._v(" "), _c('p', {
    staticClass: "s1"
  }, [_vm._v("6. "), _c('span', {
    staticClass: "c"
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "href": "#/OPS/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oh Glorious Sight")])])]), _vm._v(" "), _c('p', {
    staticClass: "s1"
  }, [_vm._v("first published in "), _c('span', {
    staticClass: "c1"
  }, [_vm._v("Oceans of Magic")]), _vm._v(", edited by Martin H. Greenberg & Brian Thomsen, DAW Books Inc., 2001; republished in "), _c('span', {
    staticClass: "c1"
  }, [_vm._v("Year’s Best Fantasy and Horror")]), _vm._v(", edited by Ellen Datlow & Terry Winding, St. Martins, 2001; collected in "), _c('span', {
    staticClass: "c1"
  }, [_vm._v("Relative Magic")]), _vm._v(", Meisha Merlin, 2003")]), _vm._v(" "), _c('p', {
    staticClass: "s1"
  }, [_vm._v("7. "), _c('span', {
    staticClass: "c"
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "href": "#/OPS/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All Things Being Relative")])])]), _vm._v(" "), _c('p', {
    staticClass: "s1"
  }, [_vm._v("first published in "), _c('span', {
    staticClass: "c1"
  }, [_vm._v("Villains Victorious")]), _vm._v(", edited by Martin H. Greenberg & John Helfers, DAW Books Inc., 2001; collected in "), _c('span', {
    staticClass: "c1"
  }, [_vm._v("Relative Magic")]), _vm._v(", Meisha Merlin, 2003")]), _vm._v(" "), _c('p', {
    staticClass: "s1"
  }, [_vm._v("8. "), _c('span', {
    staticClass: "c"
  }, [_c('span', {
    staticClass: "link",
    attrs: {
      "href": "#/OPS/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slow Poison")])])]), _vm._v(" "), _c('p', {
    staticClass: "s1"
  }, [_vm._v("first published in "), _c('span', {
    staticClass: "c1"
  }, [_vm._v("In the Shadow of Evil")]), _vm._v(", edited by Martin H. Greenberg & John Helfers, DAW Books Inc., 2005; collected in "), _c('span', {
    staticClass: "c1"
  }, [_vm._v("Finding Magic")]), _vm._v(", ISFiC Press, 2007")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4430bfd3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OPS/chapter1.vue
// module id = 60
// module chunks = 0